import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReservationSetting } from 'src/app/models/ReservationSettings';
import { ReservationService } from 'src/app/services/reservation/reservation.service';

@Component({
  selector: 'app-snooze-reservation-modal',
  templateUrl: './snooze-reservation-modal.component.html',
  styleUrls: ['./snooze-reservation-modal.component.scss']
})
export class SnoozeReservationModalComponent {
  @Input() modelId: any;
  @Input() modalName: string;
  @Input() title: string;
  @Input() modalType: string;
  @Input() routeName: string;
  @Input() selectedOutlet: string;
  @Input() generalSettings: ReservationSetting;
  @Input() contentChanges: boolean;
  @Output() snoozeAction = new EventEmitter();
  submitted: any = false
  brand: any = false
  isSuccess: any = false
  loading: any = false
  formMessage: any = ''
  type: any = ''
  isSnooze: boolean = true

  availableTimes = [
    { id: 0, timeZone: '1 Hour', day: 'today', value: '1_hour' },
    { id: 1, timeZone: '3 Hours', day: 'today', value: '3_hour' },
    { id: 2, timeZone: 'Next Day', day: 'other', value: 'next_day' },
    { id: 3, timeZone: '1 Week', day: 'other', value: '1_week' },
    { id: 4, timeZone: 'Forever', day: 'other', value: 'forever' },
    { id: 5, timeZone: 'Custom Hours', day: 'other', value: 'custom_hours' },
    { id: 6, timeZone: 'Custom Days', day: 'other', value: 'custom_days' },
  ];

  constructor(
    private reservationService: ReservationService
  ) {
  }
  ngOnInit(): void {
    this.submitted = false;

    this.snoozeReservationForm.patchValue(this.generalSettings)

  }

  ngOnChanges() {
    //console.log(this.contentChanges, this.generalSettings, this.generalSettings?.reservation_available_in, "this.contentChanges", this.modalType);
    this.submitted = false;
    if (this.contentChanges) {
      this.snoozeReservationForm.patchValue({
        snooze: this.modalType == 'snooze-reservation' ? this.generalSettings?.snooze_reservation.toString() : this.generalSettings?.snooze_auto_confirmation.toString(),
        reservation_available_in: this.generalSettings?.reservation_available_in == null ? '' : '',
      })
    } else {
      this.clearFormData()
    }
  }

  snoozeReservationForm: FormGroup = new FormGroup({
    snooze: new FormControl(''),
    reservation_available_in: new FormControl(''),
    custom_value: new FormControl(1),
  })

  get sf() { return this.snoozeReservationForm.controls; }

  clearFormData() {
    this.snoozeReservationForm.removeControl('snooze');
    this.snoozeReservationForm.removeControl('reservation_available_in');
    this.snoozeReservationForm.removeControl('custom_value');

    this.snoozeReservationForm.addControl('snooze', new FormControl(''));
    this.snoozeReservationForm.addControl('reservation_available_in', new FormControl(''));
    this.snoozeReservationForm.addControl('custom_value', new FormControl(1));

  }

  selectTimezone(type: any) {
    console.log(type, 'time');
    this.type = type
    //this.available_time = time.value
  }

  onCancelClick() {
    this.snoozeAction.emit()
  }

  onClick(type) {
    //console.log(type, 'type');

    if (type == 'snooze') {
      this.snoozeReservationForm.controls['reservation_available_in'].setValidators(Validators.required);
      this.snoozeReservationForm.controls['reservation_available_in'].updateValueAndValidity()
    } else {
      this.snoozeReservationForm.removeControl('reservation_available_in');
      this.snoozeReservationForm.addControl('reservation_available_in', new FormControl(''));
    }
    // this.snoozeReservationForm.patchValue({
    //   reservation_available_in: '',
    // })
  }

  onSaveClick() {
    this.submitted = true
    this.loading = true
    console.log(this.snoozeReservationForm, this.snoozeReservationForm.invalid);

    if (!this.snoozeReservationForm.invalid) {
      console.log("form vaild");
      const formData = new FormData();

      formData.append('snooze', this.snoozeReservationForm.value.snooze)

      formData.append('available_from', this.snoozeReservationForm.value.reservation_available_in)
      if (this.type == 'custom_hours' || this.type == 'custom_days') {
        formData.append('custom_value', this.snoozeReservationForm.value.custom_value)
      }
      formData.append('_method', 'PUT');

      if (this.modalType == 'snooze-reservation') {
        this.reservationService.snoozeReservation(this.selectedOutlet, formData)
          .subscribe({
            next: (res) => {
              console.log(res);
              // this.getGeneralSetiings();.
              this.snoozeAction.emit()
              this.submitted = false;
              this.loading = false;
            },
            error: (error) => {
              console.log(error);
              this.submitted = false;
              this.loading = false;
              this.formMessage = error
            }
          })
      } else {
        this.reservationService.snoozeAutoConfirmation(this.selectedOutlet, formData)
          .subscribe({
            next: (res) => {
              console.log(res);
              // this.getGeneralSetiings();.
              this.snoozeAction.emit()
              this.submitted = false;
              this.loading = false
            },
            error: (error) => {
              console.log(error);
              this.submitted = false;
              this.loading = false;
              this.formMessage = error
            }
          })

      }


    } else {
      console.log("Invalid Form");
      this.loading = false
      //this.submitted = false;
    }

  }

}
